import { CardMenuProps } from '@/routes/home/card/Card.types'
import { DropDownButton } from 'devextreme-react/drop-down-button'

const CardMenu = (props: CardMenuProps) => {
  const { visible = true, menuItems } = props

  return (
    <DropDownButton
      className="overflow-menu"
      items={menuItems}
      visible={visible}
      icon="overflow"
      stylingMode="text"
      showArrowIcon={false}
      dropDownOptions={{ width: 'auto' }}
      useItemTextAsTitle={false}
    />
  )
}

export default CardMenu
